var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcoreLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880.4 809.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.8,646.5c-56.6,0-96.7-40-96.7-96.7v-290.1c0-56.7,40-96.7,96.7-96.7h306.6c56.6,0,96.7,40,96.7,96.7v96h-100.2l-60.1-104.3h-176.1l-89.1,153.3,89.1,153.3h176.1l60.1-104.3h100.2v96c0,56.6-40.1,96.7-96.7,96.7h-306.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "488.5 323.2 536.2 404.8 488.5 486.3 394.6 486.3 346.9 404.8 394.6 323.2 488.5 323.2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcoreLogoWhite);
export default __webpack_public_path__ + "static/media/Procore_Logo_White.e0503b8a81673b757f49a45b5ce6e43c.svg";
export { ForwardRef as ReactComponent };